module.exports = __webpack_public_path__ + "static/media/crm-icon.5961408f.svg";